module.exports = __webpack_public_path__ + "img/splek-dashboard.fa19c4f9.jpg";